<template>
  <div class="modalUser">
    <b-modal id="modalDeleteEmployee" ref="modalDeleteEmployee" modal-class="modalsmall top-mb" centered no-close-on-backdrop>
      <template v-slot:modal-header>
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <h2 class="title text-uppercase">社員削除</h2>
          <p class="sub-title">この社員を削除してよろしいでしょうか</p>
        </div>
      </template>
      <div class="modalUser--main">
        <div class="imageDeleteUser">
          <img src="@img/admin/delete-vendor.svg" alt="" class="img-fluid">
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 button-group">
          <button
            class="btn btn-rounder btn-danger btn-login btn-primary w-100"
            type="button" @click="deleteCompany">削除</button>
        </div>
        <button
          class="btn btn-rounder btn-second btn-cancel w-100"
          type="button" @click="back">キャンセル</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
export default {
  name: 'Delete_Employee_view',
  components: {
    'b-modal': BModal
  },
  props: {
    idDelete: {
      Type: Number,
      Defaults: null
    }
  },
  methods: {
    deleteCompany () {
      this.$store.dispatch('adminEmployee/deleteEmployee', {id: this.idDelete, modal: this.$refs['modalDeleteEmployee'], company_id: this.$route.params.id})
    },
    back () {
      this.$refs['modalDeleteEmployee'].hide()
    }
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  data () {
    return {
      modalShow: false
    }
  }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Employee/Delete.vue